import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';
import { FDealType, getDealType } from 'shared/utils/deal_type';

export type TUxfbDealType = 'sale' | 'rent';
export type TUxfbOfferType = 'flat' | 'suburban' | 'commercial';
export type TUxfbYesNo = 'yes' | 'no';

/** deal_type по контракту UXFB: посуточная аренда считается rent. */
export const getUxfbDealType = (offer: IOfferSchema): TUxfbDealType =>
  getDealType(offer) === FDealType.Sale ? 'sale' : 'rent';

export interface IGetOpenOfferCardAttributesParams {
  offer: IOfferSchema;
  /**
   * Вертикаль карточки для атрибута offer_type; передаётся контейнером страницы явно
   * (Flat/Newbuilding → flat, Suburban → suburban, Commercial → commercial,
   * DailyRent → suburban для dailyHouseRent и flat для остальных посуточных категорий).
   */
  offerType: TUxfbOfferType;
  /** Объявление в новостройке от застройщика или его представителя. */
  fromDeveloper: boolean;
  /** Посуточная аренда. Событие не подавляем — шлём с is_daily=yes. */
  isDaily: boolean;
}

/** Атрибуты события `open_offer_card` (заход на карточку). property_type/listing_type по контракту не шлются. */
export const getOpenOfferCardAttributes = ({
  offer,
  offerType,
  fromDeveloper,
  isDaily,
}: IGetOpenOfferCardAttributesParams): Record<string, string> => ({
  platform: 'desktop',
  category: offer.category,
  fromDeveloper: fromDeveloper ? 'yes' : 'no',
  deal_type: getUxfbDealType(offer),
  offer_type: offerType,
  is_daily: isDaily ? 'yes' : 'no',
});
